export const SurveyBoxGenericFooterBtnWidth = '250px';
